import { AutoCompleteOption } from "@asayinc/component-library";

export const LOCATION_ANALYSIS_EVENT_TYPE_OPTIONS: AutoCompleteOption[] = [
  {
    name: "USA Only",
    id: "usa_only",
  },
  {
    name: "International Only",
    id: "international_only",
  },
  {
    name: "USA and International",
    id: "usa_and_international",
  },
];
